import { render, staticRenderFns } from "./ShoppingCart.vue?vue&type=template&id=8f2d9478&scoped=true"
import script from "./ShoppingCart.vue?vue&type=script&lang=ts"
export * from "./ShoppingCart.vue?vue&type=script&lang=ts"
import style0 from "./ShoppingCart.vue?vue&type=style&index=0&id=8f2d9478&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2d9478",
  null
  
)

export default component.exports